/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  private httpClient = inject(HttpClient)

  public getEmailsForProfile(country: string, language: string): Observable<EmailCommunicationDto[]> {
    return this.httpClient.get<EmailCommunicationDto[]>(`${environment.publicApi.baseUrl}/emails?country=${country}`, {
      headers: { 'accept-language': language },
    })
  }

  public updateEmailFromProfile(country: string, language: string, emailId: string, dto: EmailCommunicationDto): Observable<void> {
    return this.httpClient.put<void>(`${environment.publicApi.baseUrl}/emails/${emailId}?country=${country}`, dto, {
      headers: { 'accept-language': language },
    })
  }

  public deleteEmailFromProfile(country: string, language: string, emailId: string): Observable<void> {
    return this.httpClient.delete<void>(`${environment.publicApi.baseUrl}/emails/${emailId}?country=${country}`, {
      headers: { 'accept-language': language },
    })
  }

  public createEmailForProfile(country: string, language: string, dto: EmailCommunicationDto): Observable<void> {
    return this.httpClient.post<void>(`${environment.publicApi.baseUrl}/emails?country=${country}`, dto, {
      headers: { 'accept-language': language },
    })
  }
}

export interface EmailCommunicationDto {
  email?: string
  emailId?: string
  isPending?: boolean
  isPorscheId?: boolean
  isStandard?: boolean
  isVerified?: boolean
  usage?: 'home' | 'work'
}
